export default __webpack_public_path__ + "static/media/builder-logo.50418dd0.png";